import { memo } from 'react';

import StringIcon from '@/assets/field-type-string.svg?react';
import { merge } from '@/components';
import { FormatterValidatorLogo, VariantLogoProps } from '@/components/logos';

export type StringLogoProps = VariantLogoProps;

const IStringLogo = ({ className, ...rest }: StringLogoProps) => {
  return (
    <FormatterValidatorLogo Icon={StringIcon} className={merge('bg-purple-50 text-purple-700', className)} {...rest} />
  );
};

export const StringLogo = memo(IStringLogo) as typeof IStringLogo;
